<template>
  <div class="workspace-recent-reviews">
    <v-skeleton-loader v-if="initial_loading || loading_reviews" type="list-item-avatar-three-line, list-item-avatar-three-line" />
    <p v-else-if="!reviews.length" class="workspace-empty">No reviews yet.</p>
    <article v-else v-for="item in reviews" :key="item.id" class="workspace-review-item">
      <span class="workspace-avatar workspace-avatar--round" aria-hidden="true">{{ (item.name || '?').split(/\s+/).slice(0,2).map(word => word[0]).join('').toUpperCase() }}</span>
      <div class="workspace-review-body">
        <div class="workspace-review-meta"><strong>{{ item.name }}</strong><span v-if="item.rating_value" class="workspace-stars" :aria-label="item.rating_value + ' out of 5 stars'">{{ '★'.repeat(Math.min(5, Math.max(0, Math.round(Number(item.rating_value) || 0)))) }}</span><time>{{ formatDate(item.date) }}</time><span class="workspace-source-label">{{ getHostname(item) === 'google.com' ? 'Google' : getHostname(item) }}</span></div>
        <p v-if="item.review_text">{{ item.show_all ? item.review_text : String(item.review_text).slice(0,180) }}<span v-if="!item.show_all && String(item.review_text).length > 180">… <button type="button" class="workspace-text-button" @click="$set(item, 'show_all', true)">Read more</button></span></p>
        <div v-if="item.user" class="workspace-review-context"><span>{{ item.user.company_name || (item.user.parent && item.user.parent.company_name) }}</span><span>{{ item.user.city || item.user.country }}</span></div>
      </div>
    </article>
  </div>
</template>
<script>
import ReviewsTableOld from '@/components/ReviewsTableOld.vue';
// Retain the original dashboard review request, loading state and date/site helpers.
export default {
  extends: ReviewsTableOld,
  data() { return { options: { sortBy: 'Newest First', sortDesc: true, page: 1, itemsPerPage: 5 } }; }
};
</script>
